import { buildExportFilename } from 'utils/formatCSV';
import { useCallback } from 'react';

// An explicit `null` entity override is honoured; only `undefined` falls back.
const useExportName = ({ country, source, entity, date }) =>
    useCallback(
        (type = null, { kind = 'data', entity: override } = {}) =>
            buildExportFilename({
                date,
                country,
                source,
                entity: override === undefined ? entity : override,
                type,
                kind,
            }),
        [country, source, entity, date],
    );

export default useExportName;
